'use client';

import { Routes, Route, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { paths } from './routes';
import Layout from './Layout';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Debts from './pages/Debts';
import ApiKeys from './pages/ApiKeys';
import Institutions from './pages/Institutions';
import Profile from './pages/Profile';
import LoadingSpinner from './components/LoadingSpinner';
import ProtectedRoutes from './components/ProtectedRoutes';

function App() {
	const { isAuthenticated } = useSelector((state) => state.auth);

	return (
		<Routes>
			{/* Default Route */}
			<Route
				path='/'
				element={
					<Navigate
						to={paths.DASHBOARD}
						replace
					/>
				}
			/>
			
			{/* Public Routes */}
			<Route path={paths.LOGIN} element={<Login />} />
			<Route path={paths.REGISTER} element={<Register />} />

			{/* Protected Routes */}
			<Route element={<ProtectedRoutes />}>
				<Route path={paths.HOME} element={<Layout />}>
					<Route
						index
						element={
							<Navigate
								to={paths.DASHBOARD}
								replace
							/>
						}
					/>
					<Route path='dashboard' element={<Dashboard />} />
					<Route path='debts' element={<Debts />} />
					<Route path='api-keys' element={<ApiKeys />} />
					<Route path='institutions' element={<Institutions />} />
					<Route path='profile' element={<Profile />} />
				</Route>
			</Route>

			{/* 404 Route */}
			<Route
				path='*'
				element={
					<Navigate
						to={isAuthenticated ? paths.DASHBOARD : paths.LOGIN}
						replace
					/>
				}
			/>
		</Routes>
	);
}

export default App;
